import { FORUM_URL, MINERVA_RESOURCES_ENVIRONMENT, MINERVA_RESOURCES_URL } from "config";

/**
 * Forum API
 */

const classPathParts = window.location.pathname.split("/").slice(1, 4);
export const forumClassUrl = `${FORUM_URL}/app/${classPathParts.join("/")}`;

/**
 * Minerva Resources API
 */

export async function getWorkbookData(resourceUuid: string, sessionId: string, orgId: number) {
  return fetch(
    `${MINERVA_RESOURCES_URL}/api/v1/doc?${new URLSearchParams({
      session_key: `${MINERVA_RESOURCES_ENVIRONMENT}-${orgId}-${sessionId}`,
      id: resourceUuid,
    }).toString()}`,
    {
      method: "GET",
    },
  );
}

export async function enableCaptionsTracking(resourceUuid: string) {
  return fetch(`${MINERVA_RESOURCES_URL}/api/v1/enable-captions-tracking/${resourceUuid}`, {
    method: "POST",
  });
}

export async function disableCaptionsTracking(resourceUuid: string) {
  const url = `${MINERVA_RESOURCES_URL}/api/v1/disable-captions-tracking/${resourceUuid}`;
  const blob = new Blob([]);
  navigator.sendBeacon(url, blob);
}

export async function getLatestCaption(resourceUuid: string) {
  return fetch(`${MINERVA_RESOURCES_URL}/api/v1/latest-caption/${resourceUuid}`, {
    method: "GET",
  });
}
